import React from "react";
import { Modal } from "antd";
import successTick from "../../assets/logos/success-tick.svg";

const SuccessModal = ({ isOpen, onClose, message = "Assignment created successfully" }) => {
  return (
    <Modal
      open={isOpen}
      onCancel={onClose}
      footer={null}
      centered
      closable
      width={400}
      bodyStyle={{
        textAlign: "center",
        padding: "40px 24px",
        borderRadius: "16px",
      }}
    >
      <img src={successTick} alt="Success" style={{ marginBottom: "16px" }} />
      <h2 style={{ fontWeight: "600", fontSize: "20px", margin: 0 }}>{message}</h2>
    </Modal>
  );
};

export default SuccessModal;
